import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ExecutiveDashboardPage } from "@/components/executive/executive-dashboard-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/executive",
  component: ExecutiveGuard,
});

function ExecutiveGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as { role?: string } | undefined)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <ExecutiveDashboardPage />;
}
